/*******************************************************
 * SUBSCRIPTION SERVICE
 *
 * Gestion des abonnements et abonnés
 *******************************************************/

"use strict";


angular.module("services")

	.factory("FitiSubscriptionService", ["$http", "ENV", function (ENV, $http) {



		// PUBLIC API
		return {
			getAddress: getAddress,
			getAddressWithStopAreas: getAddressWithStopAreas,
			getRouteGeometryFromPolyLine: getRouteGeometryFromPolyLine
		};



		/**
		 * Récupérer des propositions d'adresses
		 * @param address
		 * @returns {HttpPromise}
		 */
		function getAddress(address) {
			return $http.get(ENV.API_URL + "/osrm/search-address/" + address);
		}

		/**
		 * Récupérer des propositions d'adresses et points arrêts
		 * @param address
		 * @returns {HttpPromise}
		 */
		function getAddressWithStopAreas(address) {
			return $http.get(ENV.API_URL + "/osrm/search-address/" + address + "?stop-areas=true");
		}

		/**
		 * Récupérer les infos d'une route tracé
		 * @param listOfPoints
		 * @returns {HttpPromise}
		 */
		function getRouteGeometryFromPolyLine(listOfPoints) {
			return $http.post(ENV.API_URL + "/osrm/route", listOfPoints);
		}


}]);
